<template>
  <uni-popup ref="check" type="bottom">
    <uni-card title="治疗" :is-full="true">
      <div class="gridClass">
        <div class="grid_wrap">
          <div
            v-for="(item, i) in prescripTypeList"
            :key="i"
            class="grid-item"
            @click="selectPre(item, i)"
          >
            <img
              v-if="i == selectedIndex"
              class="grid-icon"
              :src="require('@funcPuzzle/mini_doctor/' + item.selectImg + '.png')"
            />
            <img
              v-else
              class="grid-icon"
              :src="require('@funcPuzzle/mini_doctor/' + item.img + '.png')"
            />
            <span :class="i == selectedIndex ? 'select_grid_text' : 'grid_text'">
              {{ item.text }}
            </span>
          </div>
        </div>
      </div>
      <template v-slot:close>
        <uni-icons type="closeempty" color="#666" @click="close" />
      </template>
    </uni-card>
  </uni-popup>
</template>

<script>
import { mapState } from 'vuex'
import { getKeyValue } from '@/views/funcPuzzle/utils/util.js'
import { getBusinessDicList } from '@/views/funcPuzzle/utils/index.js'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    }
  },
  data() {
    return {
      prescripList: [
        {
          selectImg: 'inspect',
          img: 'inspectDefault',
          text: '检查',
          code: '1'
        },
        {
          selectImg: 'checkout',
          img: 'checkoutDefault',
          text: '检验',
          code: '2'
        },
        {
          selectImg: 'treat',
          img: 'treatDefault',
          text: '治疗',
          code: '4'
        },
        {
          selectImg: 'ssss_active',
          img: 'ssss_default',
          text: '手术申请',
          code: '5'
        }
      ],
      selectedIndex: '0',
      drugTypeOption: [],
      prescripTypeList: []
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.prescripTypeList = []
          this.drugTypeOption = []
          // this.open()
          this.$refs.check.open()
        } else {
          this.close()
        }
      }
    },
    modelValue(val) {
      if (val) {
        this.$refs.check.open()
        // this.open()
      } else {
        this.close()
      }
    }
  },
  methods: {
    getKeyValue,
    getCheckOption(type) {
      return this.getKeyValue('item_type').filter(item => {
        return item.code === type
      })
    },
    getBusinessConfig() {
      this.prescripTypeList = []
      this.drugTypeOption = []

      getBusinessDicList({
        pageNum: 1,
        pageSize: 1,
        tableName: 'item_type',
        code: this.hospitalID
      }).then(rs => {
        const data = JSON.parse(rs.DoctorServicePackageList[0].value)
        data.item_type.sort((a, b) => {
          return a.order - b.order
        })
        data.item_type.map(item => {
          const _item = this.getCheckOption(item.itemType)
          this.drugTypeOption = this.drugTypeOption.concat(_item)
        })

        this.drugTypeOption.forEach(item => {
          this.prescripTypeList.push(
            this.prescripList.filter(item2 => {
              return item.code === item2.code
            })[0]
          )
        })
      })
    },
    selectPre(item, i) {
      if (item.code === '5') {
        // 手术申请, 不想用之前的页面了太乱，新弄一个页面展示/编辑手术
        this.selectedIndex = i
        this.$emit('selected', item)
        this.close()
        return
      }
      this.selectedIndex = i
      this.close()
      this.$bus.emit('checkType', item.code)
      // this.$bus.$emit('showSelectCheck')
    },
    close() {
      if (!this.$refs.check) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.check.close()
    },
    open() {
      this.getBusinessConfig()
      this.$emit('update:visible', true)
      this.$refs.check.open()
    }
  },
  mounted() {
    this.$bus.on('showSelectCheck', () => {
      this.selectedIndex = '0'
      this.open()
    })
  },
  unmounted() {
    this.$bus.off('checkType')
  }
}
</script>

<style lang="scss" scoped>
.gridClass {
  padding-top: 0.853333rem;
  background-color: #fff;
  min-height: 7.04rem;
  .grid_wrap {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    height: 100%;
    align-items: center;
  }
  .tips {
    width: 100%;
    text-align: center;
    font-size: 0.64rem;
    font-weight: 400;
    color: #222222;
    line-height: 0.896rem;
  }
  ::v-deep .uni-grid-item__box {
    display: flex;
    justify-content: center;
  }
  .grid-item {
    // margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    width: 33.33%;
    margin-bottom: 1.109333rem;
    .grid-icon {
      width: 2.133333rem;
      height: 2.133333rem;
      margin-bottom: 0.341333rem;
    }
    .grid-text {
      font-size: 0.554667rem;
      color: #767676;
    }
    .select_grid_text {
      font-size: 0.554667rem;
      color: #0089ff;
    }
  }
}
.footer-box {
  text-align: center;
  width: 14.933333rem;
  height: 1.536rem;
  background: #2772ff;
  line-height: 1.536rem;
  border-radius: 0.213333rem;
  font-size: 0.554667rem;
  .btn {
    color: #fff;
  }
}
</style>
